// extracted by mini-css-extract-plugin
export default {"customButton":"CustomButton_customButton__MBhd2","activePage":"CustomButton_activePage__VUXoU"};